import React from 'react';

import Refresh from 'shared/ui/icons/General/Refresh';
import IconButton, {IIconButtonProps} from 'shared/ui/IconButton/IconButton';

import styles from './IconButton.module.scss';

type IEditButtonProps = Omit<IIconButtonProps, 'icon'> & {
    iconSize?: number;
    disabled?: boolean;
    isRefreshing?: boolean;
};

const RefreshButton: React.FC<IEditButtonProps> = ({disabled, isRefreshing = false, ...props}) => {
    return (
        <IconButton
            icon={
                <div className={isRefreshing ? styles.refreshingIcon : ''}>
                    <Refresh />
                </div>
            }
            {...props}
            disabled={disabled || isRefreshing}
        />
    );
};

export default RefreshButton;